export default "<p>report-summary works!</p>\r\n";